import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { BRANDS_CATEGORIES_PAGE_PATH } from "utils/constants/paths";

const BrandsCategoriesPage = Loadable(React.lazy(() => import("./View")));

export const BrandsCategoriesRoute: IRouteItem = {
  path: BRANDS_CATEGORIES_PAGE_PATH,
  element: React.createElement(BrandsCategoriesPage),
  name: "Categories",
};
